import { OWNER_UNASSIGNED } from './crm-owner-filter';
import { ScheduleFilter } from './crm-schedule-filter';

export interface LeadListQueryInput {
    boardId: string;
    search: string;
    statusId: string | null;
    /// Id do responsável, OWNER_UNASSIGNED ou nulo para todos.
    ownerFilter?: string | null;
    /// Id da tag ou nulo para todas.
    tagFilter?: string | null;
    includeClosed: boolean;
    scheduleFilter: ScheduleFilter | null;
    now: Date;
}

/// Intervalo do compromisso aberto mais próximo: "a partir de" inclusivo, "antes de" exclusivo.
/// Igual ao matchesScheduleFilter (fim do dia 23:59:59.999 com "<="), no dia do relógio de quem olha.
function scheduleBounds(filter: ScheduleFilter, now: Date): { from?: Date; to?: Date } {
    if (filter === 'late') return { to: now };

    const endOfToday = new Date(now);
    endOfToday.setHours(23, 59, 59, 999);

    if (filter === 'today') return { from: now, to: new Date(endOfToday.getTime() + 1) };

    const endOfWeek = new Date(endOfToday);
    endOfWeek.setDate(endOfWeek.getDate() + 7);

    return { from: now, to: new Date(endOfWeek.getTime() + 1) };
}

/// A querystring da lista de leads, a partir dos filtros da barra do quadro.
export function buildLeadListQuery({
    boardId, search, statusId, ownerFilter = null, tagFilter = null, includeClosed, scheduleFilter, now,
}: LeadListQueryInput): string {
    const params = [`boardId=${encodeURIComponent(boardId)}`];
    const term = search.trim();

    if (term) params.push(`search=${encodeURIComponent(term)}`);
    if (statusId) params.push(`statusId=${encodeURIComponent(statusId)}`);

    if (ownerFilter === OWNER_UNASSIGNED) params.push('unassigned=true');
    else if (ownerFilter) params.push(`ownerId=${encodeURIComponent(ownerFilter)}`);

    if (tagFilter) params.push(`tagId=${encodeURIComponent(tagFilter)}`);

    // Mesma regra do quadro: o filtro de agenda é sobre o que precisa de ação.
    if (includeClosed && scheduleFilter === null) params.push('includeClosed=true');

    if (scheduleFilter === 'none') {
        params.push('withoutSchedule=true');
    } else if (scheduleFilter !== null) {
        const { from, to } = scheduleBounds(scheduleFilter, now);

        if (from) params.push(`scheduleFrom=${encodeURIComponent(from.toISOString())}`);
        if (to) params.push(`scheduleTo=${encodeURIComponent(to.toISOString())}`);
    }

    return '?' + params.join('&');
}
